// extracted by mini-css-extract-plugin
module.exports = {"completeInvitation":"CompleteInvitation_completeInvitation__1hegk"};